module.exports = __webpack_public_path__ + "static/media/playTBN.eafe6dd6.png";